import styled from 'styled-components';

// ----------------------------------------------------------------------

export const LoginWrapper = styled.div`
  border-radius: 20px;
  box-shadow: 0 10px 20px 0 #060A251A;
  display: flex;
  width: 1000px;
  height: 600px;
  overflow: hidden;

  > * {
    width: 50%;
  }
    
  ${({theme}) => theme.media.lg`
    width: 100%;
  `};
    
  ${({theme}) => theme.media.md`
    height: auto;
    box-shadow: none;
  `};
`;

export const LoginVisual = styled.div`
  background-image: url(/assets/main/bg.svg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
    
  ${({theme}) => theme.media.md`
    display: none;
  `};
`;

export const LoginForm = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #FFFFFF;

  > form {
    width: 360px;
    
    > div:first-child {
      width: 320px;
      height: 57px;
      background-image: url(/assets/logo/logo.svg);
      background-size: 100% auto;
      background-position: center center;
      background-repeat: no-repeat;
      margin-bottom: 30px;
    }

    > div:last-child {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 13px;
      color: #6B7A99;

      > label {
        display: flex;
        align-items: center;
        gap: 5px;
      }

      > p {
        line-height: 20px;

        > a {
          color: #7D8FB3;
          margin-left: 2px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
    
  ${({theme}) => theme.media.md`
    width: 100%;

    > form {
      width: 100%;
      padding: 0 10px;

      > div:first-child {
        margin: 0 auto 30px;
      }
    }
  `};
`;

export const AuthWrapper = styled.div`
  width: 600px;
  padding: 50px 70px;
  border-radius: 20px;
  box-shadow: 0px 2px 5px 0px #26334D1A;
  background-color: #FFFFFF;
    
  ${({theme}) => theme.media.md`
    width: 100%;
   padding: 0;
    box-shadow: none;
  `};
`;

export const FormTitle = styled.div`
  text-align: center;
  margin-bottom: 20px;

  p {
    color: ${({theme}) => theme.colors.primary[400]};
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  span {
    color: #7D8FB3;
    line-height: 20px;
  }
`;

export const NextButton = styled.button`
  margin: 0 auto;
  color: #6B7A99;
  display: flex;
  align-items: center;

  > div {
    width: 24px;
    height: 24px;
    background-image: url(/assets/base/chevron.svg);
    background-size: 24px 24px;
    background-position: right center;
    background-repeat: no-repeat;
    transform: rotate(-90deg);
  }
`;